import { Component } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { TokenAuthMode, UsfTokenService } from '@panamax/app-state';
import { ActivatedRoute, Router } from '@angular/router';
import { PATHS } from '@shared/constants/paths';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-guest-login',
  templateUrl: './guest-login.page.html',
  styleUrls: ['./guest-login.page.scss'],
})
export class GuestLoginPage implements ViewWillEnter {
  constructor(
    private tokenService: UsfTokenService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ionViewWillEnter(): void {
    this.tokenService
      .authorize(TokenAuthMode.Local, { disableErrorRedirect: true })
      .then(
        () => {
          this.router.navigate([PATHS.HOME]);
        },
        async error => {
          this.loginAsAGuest();
        },
      );
  }

  async loginAsAGuest(): Promise<void> {
    console.log('[Guest Login Page] Initiating New Guest Login');
    this.tokenService
      .authorize(TokenAuthMode.Guest, {
        zipCode: environment.defaultZipCode,
      })
      .then(
        () => {
          const returnUrl: String =
            this.activatedRoute.snapshot.queryParamMap.get('returnUrl') ||
            PATHS.SEARCH_BROWSE;
          const urlInfo = returnUrl.split('?');
          const params = this.getParams(urlInfo[1]);
          this.router.navigate([urlInfo[0]], {
            queryParams: params,
          });
        },
        async error => {
          console.log(
            '[Guest Login Page] Error logging in as a guest ' +
              JSON.stringify(error),
          );
          this.router.navigate([PATHS.LOGIN_ERROR], {
            queryParams: { errorStatus: error?.status },
          });
        },
      );
  }

  getParams(urlInfo: string) {
    const paramsObject = {};
    if (urlInfo) {
      const urlParams = new URLSearchParams(urlInfo);
      urlParams.forEach((value, key) => {
        paramsObject[key] = value;
      });
    }
    return paramsObject;
  }
}
